// ======================================================================
// File Name       : Tree
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import 'jstree/dist/jstree';
import 'jstree/dist/themes/default/style.css';

import RemoveIcon from '../images/tree/cancel_circle-24.png';
import DetailInfoIcon from '../images/tree/basic_info-24.png';
import AddIcon from '../images/tree/Add-24.png';
import VideoIcon from '../images/tree/video-alt-24.png';
import DocumentIcon from '../images/tree/document-24.png';
import LinkIcon from '../images/tree/link.png';
import { escapeHtml } from '../utils/index';

const Icon = {
  Detail: DetailInfoIcon,
  Delete: RemoveIcon,
  New: AddIcon,
  Video: VideoIcon,
  Document: DocumentIcon,
  Link: LinkIcon,
};

const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any,
      text: PropTypes.any,
      icon: PropTypes.any,
      data: PropTypes.shape({
        menu: PropTypes.arrayOf(
          PropTypes.shape({
            icon: PropTypes.string,
            onClick: PropTypes.func,
          }),
        ),
      }),
      children: PropTypes.array,
    }),
  ).isRequired,
  openAll: PropTypes.bool,
  onChange: PropTypes.func,
  onOpenNode: PropTypes.func,
  onCloseNode: PropTypes.func,
  onSelectNode: PropTypes.func,
  searchOnCondition: PropTypes.func,
  onSelectCheckbox: PropTypes.func,
};

const defaultProps = {
  openAll: false,
  onChange: () => false,
  onOpenNode: () => false,
  onCloseNode: () => false,
  onSelectNode: () => false,
  searchOnCondition: () => false,
  onSelectCheckbox: () => false,
};

const Loading = 'loading';
/**
 * TreeView
 * Draw data by tree
 *
 * @class TreeView
 * @extends {Component}
 */
class TreeView extends Component {
  /**
     * TreeView props
     * @property {object}    data               - Data displayed in tree
     * @property {function}  onChange           - Optional. Callback function when tree change
     * @property {function}  onOpenNode         - Optional. Callback function before open node
     * @property {function}  onCloseNode        - Optional. Callback function before close node
     * @property {function}  searchOnCondition  - Optional. Callback function for search condition
     * @static
     */
  static propTypes = propTypes;

  /**
     * Default props
     *
     * @static
     */
  static defaultProps = defaultProps;

  /**
     * Default icon
     *
     * @static
     */
  static Icon = Icon;

  static Loading = Loading;

  /**
     * Search data in tree with filterData
     * Add prop searchOnCondition to determine tryly condition
     *
     * @param {any} filterData
     */
  search(filterData) {
    if (filterData) {
      this.closeAll();
      $(this.tree).jstree(true).search(filterData);
    }
  }

  clearSearch() {
    $(this.tree).jstree(true).clear_search();
  }

  clearSearchAndCloseAll() {
    this.clearSearch();
    this.closeAll();
  }

  clearSearchAndOpenAll() {
    this.clearSearch();
    this.openAll();
  }

  closeAll() {
    $(this.tree).jstree(true).close_all();
  }

  openAll() {
    $(this.tree).jstree(true).open_all();
  }

  /**
     * If data really change, reload tree
     *
     * @param {any} nextProps
     * @returns {boolean}
     */
  // shouldComponentUpdate(nextProps) {
  //     if (nextProps.data === this.props.data) {
  //         return false;
  //     }
  //     return true;
  // }

  /**
     * Build search confi
     *
     * @function
     */
  buildSearchConfig() {
    $.jstree.defaults.search.close_opened_onclear = false;
    $.jstree.defaults.search.search_callback = (filterData, node) => {
      const matchCondition =
        this.props.searchOnCondition && this.props.searchOnCondition(filterData, node);
      if (matchCondition) {
        if (node.children && node.children.length > 0) {
          $(this.tree).jstree('open_node', node);
        }
        return true;
      }

      return false;
    };
  }

  /**
     * Show contextmenu by left mouse click
     */
  buildContextLeft() {
    $.jstree.plugins.contextmenuleft = function (options, parent) {
      this.bind = function () {
        parent.bind.call(this);
        this.element.on(
          'click.jstree',
          '.jstree-contextmenuleft',
          $.proxy((e) => {
            e.stopImmediatePropagation();
            $(e.target).closest('.jstree-node').children('.jstree-anchor').trigger('contextmenu');
          }, this),
        );
      };

      this.redraw_node = function (obj, deep, callback, force_draw) {
        obj = parent.redraw_node.call(this, obj, deep, callback, force_draw);
        const aTag = obj.getElementsByTagName('a')[0];
        aTag.classList.add('jstree-contextmenuleft');
        return obj;
      };
    };
  }

  /**
     * Show button controls for treen ode
     */
  treeControls() {
    $.jstree.plugins.treeControls = function (options, parent) {
      this.redraw_node = function (obj, deep, callback, force_draw) {
        obj = parent.redraw_node.call(this, obj, deep, callback, force_draw);
        const node = this.get_node($(obj).attr('id'));
        const menu = node.data.menu;
        const div = document.createElement('span');
        const iconStyle = node.icon ? '' : 'width: 0px;';
        div.className = 'tree-controls';
        const content =
        `${`${'<div class="break-text margin-right-30 text-margin-left-30">' +
          '<div class="break-text display-table" id='}${node.id}>` +
          '<span class="display-table-cell"><i class="jstree-icon jstree-themeicon jstree-themeicon-custom" role="presentation" style="background-image: url(&quot;'}${node.icon}&quot;); background-position: center center; background-size: auto; ${iconStyle}"></i></span><span>${escapeHtml(node.text)}</span></div>` +
          '</div>';
        const a = obj.childNodes[1];
        $(a).html(content);
        if (menu) {
          for (const item of menu) {
            const bt = document.createElement('span');
            bt.className = item.icon;
            if (item.onClick) {
              bt.onclick = item.onClick.bind(this, item.data, node.data);
            }
            div.appendChild(bt);
          }
          obj.insertBefore(div, obj.childNodes[1]);
        }
        return obj;
      };
    };
  }

  /**
     * Build Tree config
     *
     * @function
     */
  buildConfigTree(configInfo) {
    const data = configInfo.data;
    const iconType = configInfo.iconType;
    this.buildSearchConfig();
    this.treeControls();
    return {
      core: {
        strings: {
          'Loading ...': 'Please wait ...',
        },
        animation: 50,
        themes: { variant: 'large' },
        data,
        force_text: true,
      },
      types: {
        default: {
          icon: iconType,
        },
      },
      checkbox: {
        three_state: false, // to avoid that fact that checking a node also check others
        real_checkboxes: false,
        whole_node: false, // to avoid checking the box just clicking the node
        tie_selection: false, // for checking without selecting and selecting without checking
      },
      plugins: [
        'search',
        'types',
        // 'contextmenu',
        'treeControls',
        configInfo.checkbox ? 'checkbox' : null,
        configInfo.setState ? 'state' : null,
      ],
    };
  }

  componentDidMount() {
    const treeConfig = this.buildConfigTree(this.props);

    $(this.tree).jstree(treeConfig);

    $(this.tree).bind('ready.jstree', () => this.props.openAll && $(this.tree).jstree('open_all'));

    $(this.tree).on('changed.jstree', (e, data) => {
      this.props.onChange(e, data);
    });
    $(this.tree).on('open_node.jstree', (e, data) => {
      this.props.onOpenNode(e, data);
    });
    $(this.tree).on('close_node.jstree', (e, data) => {
      this.props.onCloseNode(e, data);
    });
    $(this.tree).on('select_node.jstree', (event, selected) => {
      this.props.onSelectNode(event, selected.node);
    });

    $(this.tree).on('check_node.jstree uncheck_node.jstree', (e, data) => {
      this.props.onSelectCheckbox(e, data);
    });

    $(this.tree).on('model.jstree', (node, parent) => {
      // console.log("========================");
      // console.info('model.jstree');
      // console.info(node);
      // console.info(parent);
    });

    // 20230605_tma START
    $(this.tree).on('load_node.jstree', () => this.props.openAll && $(this.tree).jstree('open_all'));
    // 20230605_tma END
  }

  componentDidUpdate() {
    $(this.tree).jstree(true).settings.core.data = this.props.data;
    if (!this.props.isNotRefresh) {
      $(this.tree).jstree(true).refresh();
    }
  }

  render() {
    return (
      <div className="card padding-10">
        <div
          id={this.props.id}
          ref={(elem) => {
            this.tree = elem;
          }}
        />
      </div>
    );
  }
}

export default TreeView;
